import { Outlet, ScrollRestoration } from 'react-router-dom';

import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

export function RootLayout() {
  return (
    <ErrorBoundary>
      <Outlet />
      <ScrollRestoration />
    </ErrorBoundary>
  );
}
